import _ from "lodash";

import { ISectionPlan } from "redux/modules/common/building/processTypes";

import { IClosureDate } from "shared/ui/inputs/ClosureDates/useClosureDates";
import { IExecutor } from "widgets/Executors/useExecutors";

interface IProps {
  initialData: ISectionPlan;
  dateEnd?: string;
  dateStart?: string;
  closureDates: IClosureDate[];
  executors: IExecutor[];
}

export const useSectionPlanWasChanged = ({ initialData, dateEnd, dateStart, closureDates, executors }: IProps) => {
  const datesWasChanged = initialData?.start_at !== dateStart || initialData?.end_at !== dateEnd;
  const closureDatesWasChanged = !_.isEqual(initialData.close_dates, closureDates);
  const executorsWasChanged = !_.isEqual(initialData.posts, executors);

  return {
    wasChanged: datesWasChanged || closureDatesWasChanged || executorsWasChanged,
  };
};
